export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    
    // Add a small buffer (30 seconds) to prevent edge cases where token might expire during request
    const bufferTime = 30 * 1000; // 30 seconds
    const expirationTime = payload.exp * 1000;
    const currentTime = Date.now();
    
    // Only consider token expired if it's actually expired or very close to expiration
    return expirationTime - currentTime < bufferTime;
  } catch (error) {
    console.error('Error parsing token:', error);
    return true;
  }
};

export const checkTokenExpiration = (token, dispatch, actions) => {
  if (isTokenExpired(token)) {
    dispatch(actions.logout());
    dispatch(actions.showSessionExpiredDialog());
    return true;
  }
  return false;
};
